import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M9.11 2.67a5.897 5.897 0 01-4.943 3.997v7.78a2 2 0 001.794 1.989l8.44.873a2 2 0 002.176-1.638l1.336-7.486a2 2 0 00-1.968-2.352H12.5V1.69C12.5.756 11.744 0 10.811 0c-.484 0-.914.31-1.068.77l-.633 1.9zM2 6H1v10h1V6z" fill="#000" /></svg>;